import { FeedbackNotificationProps } from '@clarke-energia/foton';

export const ENERGY_DISTRIBUTION_COMPANIES: Record<number, string> = {
  1: 'Coelba',
  2: 'Celpe',
  3: 'Cosern',
  4: 'CPFL Santa Cruz',
  5: 'Energisa MT',
  6: 'CPFL Paulista',
  7: 'Energisa MS',
  8: 'Energisa BO',
  9: 'Light',
  10: 'Energisa SE',
  11: 'Enel CE',
  12: 'Enel RJ',
  13: 'Sulgipe',
  14: 'Uhenpal',
  15: 'Cemig',
  16: 'RGE',
  17: 'Copel',
  19: 'Energisa MR',
  20: 'Cocel',
  22: 'Energisa TO',
  23: 'Energisa SS',
  24: 'Eletrocar',
  25: 'Demei',
  26: 'Hidropan',
  27: 'MUX-Energia',
  28: 'Equatorial PA',
  29: 'EDP ES',
  30: 'ELFSM',
  31: 'Celesc',
  32: 'Forcel',
  33: 'Elektro',
  34: 'Equatorial MA',
  35: 'Energisa PB',
  36: 'Cooperaliança',
  37: 'EFLJC',
  38: 'EFLUL',
  39: 'DCELT',
  40: 'Equatorial AL',
  41: 'Equatorial PI',
  42: 'CEB',
  43: 'Enel GO',
  44: 'EDP SP',
  45: 'CPFL Piratininga',
  46: 'AME',
  47: 'Roraima Energia',
  48: 'DMED',
  49: 'Chesp',
  50: 'CEEE',
  51: 'Energisa AC',
  52: 'CEA',
  53: 'Energisa RO',
  54: 'Cerrp',
  55: 'Ceripa',
  56: 'Ceres',
  57: 'Cercos',
  58: 'Cernhe',
  59: 'Cerpro',
  60: 'Certaja',
  61: 'Ceris',
  62: 'Ceral Arapoti',
  63: 'Cermissões',
  64: 'Cooperluz',
  65: 'Coprel',
  66: 'Certel',
  67: 'Ceriluz',
  68: 'Creluz-D',
  69: 'Creral',
  70: 'Cedrap',
  71: 'Cedri',
  72: 'Cejama',
  73: 'Ceraçá',
  74: 'Cerbranorte',
  75: 'Cerej',
  76: 'Cergal',
  77: 'Cergapa',
  78: 'Cergral',
  79: 'Cermoful',
  80: 'Cerpalo',
  81: 'Cersul',
  82: 'Certrel',
  83: 'Coopercocal',
  84: 'Coopera',
  85: 'Coopermila',
  86: 'Coorsel',
  87: 'Ceral Anitápolis',
  88: 'Cerim',
  89: 'Cetril',
  90: 'Cermc',
  91: 'Ceprag',
  102: 'Enel SP',
};

export enum CompanyTypeEnum {
  FACTORY = 'FACTORY',
  GAS_STATION = 'GAS_STATION',
  RESTAURANT = 'RESTAURANT',
  OTHER = 'OTHER',
  MARBLE_FACTORY = 'MARBLE_FACTORY',
  HOSPITAL = 'HOSPITAL',
}

export enum TARIFF {
  A4_GREEN = 'A4 Verde',
  A4_BLUE = 'A4 Azul',
  AS_BLUE = 'AS Azul',
  AS_GREEN = 'AS Verde',
  A3_BLUE = 'A3 Azul',
  A2_BLUE = 'A2 Azul',
  B3_STANDARD = 'B3',
  B3_OPTING = 'B3 Optante',
}

export const INVOICE_TARIFF_TO_GROUP: Record<number, keyof typeof TARIFF> = {
  2: 'A4_GREEN',
  3: 'A4_BLUE',
  4: 'AS_BLUE',
  5: 'AS_GREEN',
  6: 'A3_BLUE',
  7: 'A2_BLUE',
  8: 'B3_STANDARD',
  9: 'B3_OPTING',
};

export const TARIFFS_INDEXER: Record<keyof typeof TARIFF, { subgroup: string; tariff_modality: string }> = {
  A4_GREEN: { subgroup: 'A4', tariff_modality: 'Verde' },
  A4_BLUE: { subgroup: 'A4', tariff_modality: 'Azul' },
  AS_BLUE: { subgroup: 'AS', tariff_modality: 'Azul' },
  AS_GREEN: { subgroup: 'AS', tariff_modality: 'Verde' },
  A3_BLUE: { subgroup: 'A3', tariff_modality: 'Azul' },
  A2_BLUE: { subgroup: 'A2', tariff_modality: 'Azul' },
  B3_STANDARD: { subgroup: 'Baixa Tensão', tariff_modality: 'Padrão' },
  B3_OPTING: { subgroup: 'Baixa Tensão', tariff_modality: 'Optante' },
};

export enum SUBMARKET_INDEXER {
  north_submarket = 'Norte',
  northeast_submarket = 'Nordeste',
  midwest_southeast_submarket = 'Sudeste-Centro-Oeste',
  south_submarket = 'Sul',
}

export interface INotificationFeedbackContent {
  label: string;
  message: string;
  kind: FeedbackNotificationProps['kind'];
}

export const DEFAULT_MANAGEMENT_PRICE = 200;
